package amazon.lastmile.inject

import app.nestbridge.feature.careteam.service.CareTeamService
import app.nestbridge.feature.careteam.service.DefaultCareTeamService
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = DefaultCareTeamService::class)
public interface AppNestbridgeFeatureCareteamServiceDefaultCareTeamService {
  @Provides
  public fun provideDefaultCareTeamServiceCareTeamService(defaultCareTeamService: DefaultCareTeamService): CareTeamService = defaultCareTeamService
}
